<script>
import UiInviteDialog from '@/components/UiInviteDialog'

import GlobalDropOverlay from '@/components/ui/GlobalDropOverlay'


export default {
  name: 'UiLayer',
  components: {
    UiInviteDialog,

    GlobalDropOverlay

  },
  computed: {
    hasDialog() {
      return this.$store.state.ui.dialogs.invite
    },
  },
}
</script>

<template>
<div class="position-absolute ui-layer" :class="{
  'vh-100': hasDialog
}">
  <UiInviteDialog v-if="$store.state.ui.dialogs.invite" />
  <GlobalDropOverlay />
</div>

</template>

<style lang="scss" scoped>
.ui-layer {
  z-index: 100;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
}
</style>
